import type { ApiClient } from "@/lib/api";
import type { CreatePluginRequest, Hook, Plugin } from "../types";

export type CreatePluginResponse = Plugin & {
  hooks?: Hook[];
};

export const createPlugin = async (options: {
  client: ApiClient;
  payload: CreatePluginRequest;
}): Promise<CreatePluginResponse> => {
  const { client, payload } = options;
  const { data } = await client.post<CreatePluginResponse>("/plugins", payload);
  return data;
};
